import React from 'react';
import { Pagination, Stack, Select, MenuItem, Typography } from '@mui/material';

const Paginated = ({ 
  count, 
  page, 
  onPageChange, 
  pageSize, 
  onPageSizeChange, 
  pageSizeOptions = [5, 10, 20, 50] 
}) => {
  return (
    <Stack spacing={2} alignItems="right" sx={{ marginTop: 2 }}>
      <Pagination
        count={Math.ceil(count / pageSize)}
        page={page}
        onChange={(_, value) => onPageChange(value)}
        variant="outlined"
        shape="rounded"
        color="primary"
        size="large"
        sx={{
          '& .MuiPaginationItem-root': {
            borderRadius: '12px',
            fontWeight: 'bold',
            '&.Mui-selected': {
              backgroundColor: '#4CAF50',
              color: 'white',
              borderColor: '#4CAF50',
            },
          },
        }}
      />

      {/* <Stack direction="row" spacing={1} alignItems="center">
        <Typography>Items per page:</Typography>
        <Select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          size="small"
        >
          {pageSizeOptions.map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </Select>
      </Stack> */}
    </Stack>
  );
};

export default Paginated;
